<script>
  import { tick } from 'svelte'
  import { onMount } from 'svelte'
  import { createPostRequest } from '../src/create_request'
  import { focus } from '../src/utils'
  import { cart } from '../src/data_storage.js'
  cart.useLocalStorage()

  import {_, locale} from 'svelte-i18n'

  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  let email = ""
  let emailInput
  let password
  let passwordInput
  let errors = false

  function signIn() {
    fetch(createPostRequest('/user_sessions.json',
                        'POST',
                        JSON.stringify({user_session: {email: email, password: password}})))
      .then(response => response.json())
      .then(data => {
        console.log('signIn:')
        console.log(data)
        if (data.errors) {
          errors = data.errors
        } else if (data['user_session']) {
          dispatch('signin', {
            text: 'signedin',
            user_session: data['user_session']
          })
        } else {
          errors = "Something went wrong, try again later."
        }
      })
      .catch(err => {
        alert('error ' + err)
      })
  }

  onMount(async () => {
    console.log("login onMount")
  })
</script>

<style>
</style>

<div class="grow flex flex-col justify-center items-center">
  <div class="text-lg font-bold mt-4">{$_('please_signin')}</div>
  <form id="signin-form" class="form" on:submit|preventDefault={signIn}>
    <div>
      <label for="email">{$_('email')}</label>
      <input id="user[email]" name="email" type="email" required bind:value={email} bind:this={emailInput} use:focus/>
    </div>
    <div>
      <label for="password">{$_('password')}</label>
      <input id="user[password]" name="password" type="password" required bind:value={password} bind:this={passwordInput}/>
    </div>
    {#if errors}
      <div class="mt-3 bg-red-100 flex flex-col items-center justify-center">
        <div>{#if (errors['email'])}{$_('email')} {errors['email']}{/if}</div>
        <div>{#if (errors['password'])}{$_('password')} {errors['password']}{/if}</div>
        <div>{#if (errors['base'])}{errors['base']}{/if}</div>
      </div>
    {/if}
    <div>
      <button class="btn" type="submit">{$_('signin')}</button>
    </div>
  </form>
</div>
